import moment from 'moment'
moment.locale('fr')

/**
 * _isAcceptableHour
 * @param { moment.Moment } date
 * @returns { boolean }
 */
function _isAcceptableHour(date) {
  const currentHour = Number(date.format('HH'))
  return currentHour <= 17 && currentHour >= 9
}

/**
 * _isAcceptableDay
 * @param { moment.Moment } date
 * @returns { boolean }
 */
function _isAcceptableDay(date) {
  const dayOfWeek = date.isoWeekday()
  return dayOfWeek < 6
}

/**
 * findNextValidNotificationDate
 * @param {moment.Moment | Date} date
 * @returns { moment.Moment }
 */
export function findNextValidNotificationDate(date = moment()) {
  if (!moment.isMoment(date)) {
    date = moment(date)
  }
  let result = date.clone().add(3, 'hours')
  if (_isAcceptableHour(result) && _isAcceptableDay(result)) {
    return result
  }
  // NOTE: 3hours from date is in the evening, we wait for tomorrow at 9am
  result = date
    .clone()
    .add(1, 'day')
    .set({ hour: 9, minute: 0, second: 0, millisecond: 0 })

  while (!_isAcceptableDay(result)) {
    // NOTE: the next isAcceptableHour is on the weekend
    result.add(1, 'day')
  }
  return result
}
